<template>
  <div class="p-6 space-y-6 bg-white rounded-lg shadow">
    <h2 class="text-xl font-semibold text-gray-700">Assistant Settings</h2>
    <p v-if="!isConfigured" class="text-sm text-orange-600 bg-orange-50 p-3 rounded-md">
      <span class="font-semibold">Caution:</span> The AI model is not configured. Configure it in
      settings.
    </p>
    <div class="space-y-4">
      <div class="flex items-center justify-between p-4 border rounded-md">
        <label for="autoScreeningSwitch" class="text-gray-600">AI screening</label>
        <Switch id="autoScreeningSwitch" v-model="autoScreeningEnabled" />
      </div>
      <div class="p-4 border rounded-md space-y-3">
        <div class="flex items-center justify-between">
          <label for="autoExtractionSwitch" class="text-gray-600">AI extraction</label>
          <Switch id="autoExtractionSwitch" v-model="autoExtractionEnabled" />
        </div>
        <p v-if="autoExtractionEnabled" class="text-sm text-orange-600 bg-orange-50 p-3 rounded-md">
          <span class="font-semibold">Caution:</span> This operation could be expensive depending on
          the number of documents and their size. If you're unsure, please turn this off.
        </p>
      </div>
      <div class="p-4 border rounded-md space-y-3">
        <div class="flex items-center justify-between">
          <label for="autoSynthesisSwitch" class="text-gray-600">AI synthesis</label>
          <Switch id="autoSynthesisSwitch" v-model="autoSynthesisEnabled" />
        </div>
        <p v-if="autoSynthesisEnabled" class="text-sm text-orange-600 bg-orange-50 p-3 rounded-md">
          <span class="font-semibold">Caution:</span> This operation could be expensive depending on
          the number of documents and their size. If you're unsure, please turn this off.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Switch from "@app/components/Global/Switch.vue";
import { injectStrict } from "@app/utils/injectStrict";
import { CreateReviewKey } from "../../useCreateProjectReview";
import { computed } from "vue";
import useAiAssistant from "@app/composables/useAiAssistant";

const { preset } = injectStrict(CreateReviewKey);
const { isConfigured } = useAiAssistant();

const autoScreeningEnabled = computed({
  get: () => !preset.value.isAutoScreeningPaused,
  set: (value: boolean) => {
    preset.value.isAutoScreeningPaused = !value;
  },
});

const autoExtractionEnabled = computed({
  get: () => !preset.value.isAutoExtractionPaused,
  set: (value: boolean) => {
    preset.value.isAutoExtractionPaused = !value;
  },
});

const autoSynthesisEnabled = computed({
  get: () => !preset.value.isAutoSynthesisPaused,
  set: (value: boolean) => {
    preset.value.isAutoSynthesisPaused = !value;
  },
});
</script>
